import React from 'react'
import {Icon} from '@chakra-ui/react'

const DownloadIcon = (props) => {
    return (
        <Icon viewBox="0 0 40 40" {...props}>
            <g clipPath="url(#clip0_15361_76947)">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M5.5 5.26666C5.5 3.39222 6.8554 1.5 8.96508 1.5H27.1048C28.0654 1.5 28.9649 1.92609 29.6024 2.65413L33.5267 6.99964C34.1793 7.72653 34.5 8.68443 34.5 9.61864V34.7332C34.5 36.6075 33.1448 38.5 31.0349 38.5H8.96508C6.85531 38.5 5.5 36.6076 5.5 34.7332V5.26666ZM8.70816 4.64558C8.59802 4.77261 8.5 4.98692 8.5 5.26666V34.7332C8.5 35.013 8.59804 35.2273 8.70819 35.3544C8.81538 35.4781 8.90949 35.5 8.96508 35.5H31.0349C31.0906 35.5 31.1847 35.4781 31.2918 35.3544C31.402 35.2274 31.5 35.013 31.5 34.7332V9.61864C31.5 9.34477 31.4021 9.12448 31.2953 9.00489C31.295 9.00455 31.2947 9.00421 31.2944 9.00388L27.3672 4.65511C27.3604 4.64763 27.3537 4.64009 27.3471 4.63248C27.2515 4.52218 27.1604 4.5 27.1048 4.5H8.96508C8.90944 4.5 8.81533 4.52196 8.70816 4.64558Z"
                    fill="currentColor"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M15.4417 20.5273L20.0041 25.0899L24.5666 20.5273L26.6879 22.6487L20.004 29.3326L13.3203 22.6486L15.4417 20.5273Z"
                    fill="currentColor"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M21.5 11.5L21.5 27.5L18.5 27.5L18.5 11.5L21.5 11.5Z"
                    fill="currentColor"
                />
            </g>
            <defs>
                <clipPath id="clip0_15361_76947">
                    <rect width="40" height="40" fill="white" />
                </clipPath>
            </defs>
        </Icon>
    )
}

export default DownloadIcon
